module.exports = __webpack_public_path__ + "static/media/location-icon-black.8f0c8aa6.svg";